import React from "react";

const SIZE_MAP = {
  sm: 32,
  md: 48,
  lg: 72,
  xl: 120,
};

/**
 * Place des Énergies official logo (uses /logo-pde.jpg).
 * - size: "sm" | "md" | "lg" | "xl"  → height in px (width auto)
 * - variant: "full" | "symbol" | "white"  (Phase 2: all use the same JPG asset)
 */
export function Logo({ size = "md", variant = "full", className = "", ...rest }) {
  const height = SIZE_MAP[size] || SIZE_MAP.md;
  return (
    <img
      src="/logo-pde.jpg"
      alt="Place des Énergies"
      data-testid="logo"
      data-variant={variant}
      style={{
        height: `${height}px`,
        width: "auto",
        display: "block",
        objectFit: "contain",
        filter: "none",
        textShadow: "none",
        boxShadow: "none",
      }}
      className={className}
      {...rest}
    />
  );
}

export default Logo;
